import React from "react";
import { FastField } from "formik";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import MuiSelect from "@mui/material/Select";

const defaultOptions = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
  { value: "null", label: "n/a" },
];

export default function BooleanSelectField({
  name,
  disabled,
  label,
  options = defaultOptions,
  allowEmptyOption = true,
  size = "small",
}) {
  return (
    <FormControl fullWidth variant="outlined" size={size}>
      <FastField name={name} disabled={disabled}>
        {({ field, form, meta }) => {
          const error = (meta.touched || form.submitCount > 0) && meta.error;

          return (
            <>
              <InputLabel id={`select-label-${field.name}`} error={!!error}>
                {label}
              </InputLabel>
              <MuiSelect
                data-id={field.name}
                labelId={`select-label-${field.name}`}
                label={label}
                id={field.name}
                value={field.value === "" && allowEmptyOption ? "null" : field.value || ""}
                error={!!error}
                disabled={disabled}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                onChange={value => {
                  const selectedValue =
                    allowEmptyOption && value.target.value === "null" ? "" : value.target.value;
                  form.setFieldValue(field.name, selectedValue);
                }}
              >
                {options.map(option => (
                  <MenuItem key={option.value} value={option.value} data-id="select-item">
                    {option.label}
                  </MenuItem>
                ))}
              </MuiSelect>

              {error && (
                <FormHelperText htmlFor={field.name} error={!!error}>
                  {error}
                </FormHelperText>
              )}
            </>
          );
        }}
      </FastField>
    </FormControl>
  );
}
